/**************************************************************************************************************************************************
*   MODULE NAME     :  MasterDataApi
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  29-04-2021
*   DESCRIPTION     :  MasterData API class
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
/**************************************************************************************************************************************************/

import axios from "axios";
import config from "../config.json";

class MasterDataApi {

  static getMasterData = async () => {
    let payload = {action: "getAlertsEmailMasterData"}
    try {
      const response = await axios.post(
        `${config.Backend_URL}/search`,
        payload
      );
      return response;
    } catch (error) {
      return error;
    }
  }
  static saveMasterData = async (records) => {
    let payload = { action : "saveMasterData", records};
    try {
      const response = await axios.post(`${config.Backend_URL}/abstract`, payload);
      return response;
    } catch (error) {
      return error;
    }
  }
}


export default MasterDataApi;
